import { API_ENDPOINTS, API_HEADERS } from '../constants/api';
import { DesignThinkingWhyPayload, DesignThinkingToolStage, Guide } from '../types';

export const fetchDesignThinkingWhy = async (): Promise<DesignThinkingWhyPayload | null> => {
  const response = await fetch(API_ENDPOINTS.designThinkingWhy, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`Design Thinking Why request failed with status ${response.status}`);
  }

  const data = await response.json();

  if (Array.isArray(data)) {
    return data.length > 0 ? (data[0] as DesignThinkingWhyPayload) : null;
  }

  return data as DesignThinkingWhyPayload;
};

export const fetchDesignThinkingTools = async (): Promise<DesignThinkingToolStage[]> => {
  const response = await fetch(API_ENDPOINTS.designThinkingTools, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`Design Thinking Tools request failed with status ${response.status}`);
  }

  const data = await response.json();
  return (data as DesignThinkingToolStage[])
    .map((stage) => ({
      ...stage,
      resources: [...stage.resources].sort(
        (a, b) => (a.id ?? Number.MAX_SAFE_INTEGER) - (b.id ?? Number.MAX_SAFE_INTEGER),
      ),
    }))
    .sort((a, b) => a.id - b.id);
};

export const fetchGuide = async (): Promise<Guide[]> => {
  const response = await fetch(`${API_ENDPOINTS.guide}?archive=false`, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`Guide request failed with status ${response.status}`);
  }

  const data = await response.json();
  const guides = data as Guide[];
  return guides.filter((guide) => !guide.archive);
};
